import DownTriangle from 'app/visuals/images/icons/down-triangle.svg?react';
import Alert from 'app/visuals/images/icons/alert.svg?react';
import { Classes, Intent } from '@blueprintjs/core';
import { THEME } from 'app/theme/theme';
import { Spinner } from 'app/components/spinner';
import { styled, keyframes } from 'styled-components';

const loading = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const EXPAND_ICON_WIDTH = THEME.spacing(2);
export const WIND_MODEL_ICON_SIZE = 6;

export const LoadingWrapper = styled.span`
  display: inline-block;
  width: ${EXPAND_ICON_WIDTH}px;
  height: ${EXPAND_ICON_WIDTH}px;
  position: relative;

  &::after {
    content: '';
    width: ${EXPAND_ICON_WIDTH + 4}px;
    height: ${EXPAND_ICON_WIDTH + 4}px;
    position: absolute;
    top: -2px;
    left: -2px;
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 50%;
    animation-name: ${loading};
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: linear;
  }
`;

export const StyledSpinner = styled(Spinner).attrs(() => ({ size: EXPAND_ICON_WIDTH, intent: Intent.PRIMARY }))``;

export const ExpandIcon = styled(DownTriangle)<{ $isVisible: boolean }>`
  width: ${() => EXPAND_ICON_WIDTH}px;
  height: 4px;
  transform: rotate(${({ $isVisible }) => ($isVisible ? '0deg' : '-90deg')});
  flex-shrink: 0;
`;

export const AlertIcon = styled(Alert).attrs(() => ({ className: `${Classes.ICON} ${Classes.INTENT_DANGER}` }))`
  width: ${EXPAND_ICON_WIDTH}px;
  height: ${EXPAND_ICON_WIDTH}px;
  path {
    fill: currentColor;
  }
`;

export const WindModelIcon = styled.span`
  display: inline-block;
  position: relative;
  width: ${EXPAND_ICON_WIDTH}px;
  height: ${EXPAND_ICON_WIDTH}px;
  &::after {
    content: '';
    position: absolute;
    width: ${WIND_MODEL_ICON_SIZE}px;
    height: ${WIND_MODEL_ICON_SIZE}px;
    top: 50%;
    left: 50%;
    transform: translate(-${WIND_MODEL_ICON_SIZE / 2}px, -${WIND_MODEL_ICON_SIZE / 2}px);
    background-color: ${({ theme }) => theme.colors.mono.ui06};
    border-radius: 50%;
  }
`;
